import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import { useNavigate } from 'react-router-dom';
import { productService } from '../../service/productservice';

// Image imports
import GroundEgusi8oz from "../../public/category-img/local/Egusi-Grounded-1kg-1.jpg";
import GroundEgusi4oz from "../../public/category-img/local/Egusi-Grounded-1kg-1.jpg";
import BlendedEgusi8oz from "../../public/category-img/local/nitta-egusi_prev_ui.png";
import GroundOgbono4oz from "../../public/category-img/local/obiji-whole ogbonno.jpg";
import GroundOffor4oz from "../../public/category-img/local/obiji-ofor.jpg";
import GroundAchi4oz from "../../public/category-img/local/obiji-achi.jpg";
import DriedIru3oz from "../../public/category-img/local/nitta-dry-iru.jpg";
import DriedOhaLeaves from "../../public/category-img/local/jdb-oha_prev_ui.png";
import FermentedMelonSeed from "../../public/category-img/local/egusi-seeds-stermart-marketplace-buy-egusi-online.jpg";
import DriedEwedu from "../../public/category-img/local/jdp-ewedu_prev_ui.png";
import ogiri from "../../public/category-img/local/ogiri-okpei-600x450.jpg"
import Kilishi from "../../public/category-img/local/Kilishi.jpg";
import EwaAgonyinSauce from "../../public/category-img/local/jdp-ewa_prev_ui.png";
import TuberOfYam3Lb from "../../public/category-img/local/3-yams.jpg";
import TuberOfYam1Lb from "../../public/category-img/local/1-yam.jpeg";
import BlendedEgusi2Lb from "../../public/category-img/local/Egusi-Grounded-1kg-1.jpg";
import GroundOgbono8oz from "../../public/category-img/local/obiji-whole ogbonno.jpg";
import AchichaEde8oz from "../../public/category-img/local/obiji-achicha ede.jpg";
import PalmDrink from "../../public/category-img/local/7.jpg";
import TubersOfYam6Lb from "../../public/category-img/local/3-yams.jpg";
import TubersOfYam9Lb from "../../public/category-img/local/3-yams.jpg";
import Abacha8oz from "../../public/category-img/local/obiji-abacha_prev_ui.png";
import Akidi1Lb from "../../public/category-img/local/obiji-akidi.jpg";
import DriedIru2_4oz from "../../public/category-img/local/burlapandbarre-Driediru_prev_ui.png";
import Ogiri8oz from "../../public/category-img/local/obiji-ogiri.jpg";
import DriedOhaLeaves2oz from "../../public/category-img/local/obiji-oha.jpg";
import SmokedPanla16oz from "../../public/category-img/local/obiji-Smoked panla 16oz.jpg";
import SmokedShrimps2oz from "../../public/category-img/local/20230623_110711_1024x1024@2x.jpg";
import Ukwa16oz from "../../public/category-img/local/obiji-ukwa.jpg";
import PrekeseWhole from "../../public/category-img/local/obiji-Prekese(whole).jpg";
import PrekeseGround from "../../public/category-img/local/obiji-prekese-ground.jpg";
import UloClay4oz from "../../public/category-img/local/obiji-ulo-clay.jpg";
import OkpaFlour from "../../public/category-img/local/obiji-ukwa-floor.jpg";

export const ethnicproduct = [
  { id: "LAG001", name: "Ground egusi 8oz", brand: "Bukky's", supplier: "Bukky wholesale", price: "$4.95", img: GroundEgusi8oz, description: "Egusi is a highly nutritious and versatile ingredient commonly used in African cuisine. It is typically ground into a fine powder and used as a thickening agent in soups and stews, such as Egusi soup. Rich in protein, healthy fats, and essential vitamins." },
  { id: "LAG002", name: "Ground egusi 4oz", brand: "Bukky's", supplier: "Bukky wholesale", price: "$2.95", img: GroundEgusi4oz, description: "Egusi is a highly nutritious and versatile ingredient commonly used in African cuisine. It is typically ground into a fine powder and used as a thickening agent in soups and stews, such as Egusi soup. Rich in protein, healthy fats, and essential vitamins." },
  { id: "LAG003", name: "Blended egusi 8oz", brand: "Nittemon food", supplier: "Nittemons food", price: "$4.95", img: BlendedEgusi8oz, description: "Egusi is a highly nutritious and versatile ingredient commonly used in African cuisine. It is typically ground into a fine powder and used as a thickening agent in soups and stews, such as Egusi soup. Rich in protein, healthy fats, and essential vitamins." },
  { id: "LAG004", name: "Ground ogbono 4oz", brand: "Obiji food", supplier: "Obiji food", price: "$5.50", img: GroundOgbono4oz, description: "Ogbono, also known as wild mango or bush mango seeds, is a popular ingredient in West African cuisine, primarily used in soups. It is ground into a powder and serves as a thickening agent, giving the soup a rich, slippery texture." },
  { id: "LAG005", name: "Ground offor 4oz", brand: "Obiji food", supplier: "Obiji food", price: "$5.00", img: GroundOffor4oz, description: "Offor is a popular ingredient in West African cuisine, particularly used as a thickening agent in soups. It is derived from the seeds of the African bush mango, and its powder is added to dishes like Ofe Onugbu or other traditional soups." },
  { id: "LAG006", name: "Ground achi 4oz", brand: "Obiji food", supplier: "Obiji food", price: "$5.99", img: GroundAchi4oz, description: "Achi is a popular thickening agent in West African cuisine, particularly in soups. Made from the seeds of the Achi plant, it is dried and ground into a powder. Achi is commonly used in soups like Ofe Achi, where it helps achieve a smooth, thick consistency." },
  { id: "LAG008", name: "Dried iru 3oz", brand: "Nittemon food", supplier: "Nittemons food", price: "$3.95", img: DriedIru3oz, description: "Dried Iru, also known as locust beans or ogiri in some regions, is a fermented seasoning used widely in West African cuisine. It has a strong, pungent aroma and a distinctive, savory flavor that adds depth to soups." },
  { id: "LAG009", name: "Dried oha leaves", brand: "JDP Global", supplier: "jdpglobalfoods.com", price: "$2.50", img: DriedOhaLeaves, description: "Dried Oha leaves are the dried form of the Oha plant, commonly used in traditional West African cuisine, particularly in Nigerian soups. Oha leaves have a distinct, slightly bitter flavor and are typically added to soups like Oha soup." },
  { id: "LAG010", name: "Fermented melon seed (ogiri)", brand: "JDP Global", supplier: "jdpglobalfoods.com", price: "$3.71", img: ogiri, description: "Ogiri is a traditional fermented seasoning commonly used in West African cuisine, especially in Nigeria. It is made from fermented locust beans, melon seeds, or sometimes other seeds, and has a strong, pungent aroma and a savory, umami flavor." },
  { id: "LAG011", name: "Dried Ewedu", brand: "JDP Global", supplier: "jdpglobalfoods.com", price: "$2.20", img: DriedEwedu, description: "Dried Ewedu is the dried form of the Ewedu plant, commonly used in West African cuisine, especially in Nigerian dishes. It is known for its mucilaginous texture, which makes it an excellent thickener in soups." },
  { id: "LAG013", name: "Ewa agonyin(beans) sauce", brand: "JDP Global", supplier: "jdpglobalfoods.com", price: "$2.10", img: EwaAgonyinSauce, description: "Ewa Agonyi Sauce is a rich and flavorful Nigerian sauce typically served with Ewa (beans). It is made from a combination of ingredients such as palm oil, onions, pepper, and spices, which are cooked down to create a smooth, savory, and spicy sauce." },
  { id: "LAG014", name: "3 Tuber of yam 3LB per yam", brand: "Unbranded", supplier: "Onola African import", price: "$21.95", img: TuberOfYam3Lb, description: "Yam is a starchy tuber that is a staple food in many African countries. It has a smooth, brown skin with white or yellow flesh, depending on the variety. Yam is commonly boiled, fried, roasted, or pounded to create various dishes." },
  { id: "LAG017", name: "Achicha Ede 8oz", brand: "Obiji food", supplier: "Obiji food", price: "$6.95", img: AchichaEde8oz, description: "Achicha Ede is a traditional Nigerian dish made from pounded cocoyam, commonly eaten in the southeastern region of Nigeria. The cocoyam is boiled, pounded, and then served with various soups." },
  { id: "LAG018", name: "Nkulenu's Palm Drink 10.65FL 0Z", brand: "Nkulenu", supplier: "Onola African import", price: "$2.95", img: PalmDrink, description: "Palm wine is a traditional alcoholic beverage widely consumed in West and Central Africa, made from the sap of palm trees. The sap is harvested and fermented, resulting in a mildly sweet, slightly tangy, and sometimes fizzy drink." },
  { id: "LAG022", name: "Abacha 8oz", brand: "Obiji food", supplier: "Obiji food", price: "$6.20", img: Abacha8oz, description: "Abacha, also known as African salad, is a popular dish from the southeastern region of Nigeria. It is made from dried, shredded cassava that is soaked in water to soften, then mixed with various ingredients." },
  { id: "LAG023", name: "Akidi 1LB", brand: "Obiji food", supplier: "Obiji food", price: "$9.95", img: Akidi1Lb, description: "Akidi, also known as African black-eyed beans or cowpeas, is a popular legume in West African cuisine. The beans are often boiled and served in a variety of ways, such as in salads, soups, or stews." },
  { id: "LAG027", name: "Smoked panla 16oz", brand: "Obiji food", supplier: "Obiji food", price: "$22.95", img: SmokedPanla16oz, description: "Smoked Panla, also known as smoked mackerel, is a popular fish in West African cuisine. It is typically smoked to enhance its flavor and preserve it for longer storage. The fish has a firm texture with a smoky, savory taste." },
  { id: "LAG028", name: "Smoked shrimps 2oz", brand: "Obiji food", supplier: "Obiji food", price: "$7.95", img: SmokedShrimps2oz, description: "Smoked Shrimp (Oporo) is a popular dried seafood ingredient in West African cuisine. It is made by smoking shrimps to enhance their flavor and preserve them for longer periods." },
  { id: "LAG029", name: "Ukwa 16oz", brand: "Obiji food", supplier: "Obiji food", price: "$19.00", img: Ukwa16oz, description: "Ukwa, also known as African breadfruit, is a large, nutritious fruit native to West and Central Africa. It is typically harvested when ripe and is often boiled or roasted for consumption." },
  { id: "LAG030", name: "Prekese(whole), 4oz", brand: "Obiji food", supplier: "Obiji food", price: "$4.95", img: PrekeseWhole, description: "Prekese, also known as African pepper, is a popular spice used in West African cuisine. It is derived from the dried fruit of the Tetrapleura tetraptera tree and has a strong, aromatic flavor." },
  { id: "LAG032", name: "Ulo clay, 4oz", brand: "Obiji food", supplier: "Obiji food", price: "$5.95", img: UloClay4oz, description: "Ulo clay is a natural material used to craft traditional cooking vessels, particularly in West African cuisine. When used for cooking, Ulo clay pots are believed to offer various nutritional benefits." },
  { id: "LAG033", name: "Okpa flour (Bambara beans)", brand: "Obiji food", supplier: "Obiji food", price: "$9.95", img: OkpaFlour, description: "Okpa flour, made from Bambara beans, is a highly nutritious flour commonly used in West African cuisine. It is derived by grinding dried Bambara beans into a fine powder." }
];

const ProductCard = ({ product, updateCartCount,forceUpdateKey }) => {
  const [inCart, setInCart] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();
  
  
  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const foundItem = storedCartItems.find(item => item.id === product.id);
    if (foundItem) {
      setInCart(true);
      setQuantity(foundItem.quantity);
    } else {
      setInCart(false);
      setQuantity(0);
    }
  }, [product.id, forceUpdateKey]);

  const handleAddToCart = () => {
    if (!inCart) {
      setInCart(true);
      setQuantity(1);
      saveToLocalStorage(product, 1);
      updateCartCount(); 
  
    }
  };

  const handleProductClick = () => {
    navigate(`/product/${product.name}`);
  };

  const increaseQuantity = () => {
    setQuantity(prevQuantity => {
      const newQuantity = prevQuantity + 1;
      updateLocalStorage(product.id, newQuantity);
      updateCartCount(); 
      
      return newQuantity;
    });
  };

  const decreaseQuantity = () => {
    setQuantity(prevQuantity => {
      const newQuantity = prevQuantity - 1;
      if (newQuantity === 0) {
        setInCart(false);
        removeFromLocalStorage(product.id);
      } else {
        updateLocalStorage(product.id, newQuantity);
      }
      updateCartCount(); 
    
      return newQuantity;
    });
  };

  const saveToLocalStorage = (product, quantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = [...cartItems, { ...product, quantity }];
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  const updateLocalStorage = (productId, newQuantity) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = cartItems.map(item =>
      item.id === productId ? { ...item, quantity: newQuantity } : item
    );
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

 
  const removeFromLocalStorage = (productId) => {
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    const updatedCart = cartItems.filter(item => item.id !== productId);
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
    updateCartCount(); 
  
  };

  

  return (
    <div  className="bg-white shadow-md rounded-lg p-3 w-full flex flex-col justify-between">

          <div onClick={handleProductClick} className="relative cursor-pointer flex justify-center items-center">
            <img
              src={product.img}
              alt={product.name}
              className={`h-60 w-full object-cover rounded-lg ${product.quantity === 0 ? 'opacity-50' : ''}`}
            />
            {product.quantity === 0 && (
              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center rounded-lg">
                <span className="text-white text-lg font-semibold">Out of Stock</span>
              </div>
            )}
          </div>
          <div className="mt-4">
            <h3 className="text-lg font-semibold">{product.name}</h3>
            <p className="text-[#007D44]">{product.brand}</p>
            <p className="text-[#007D44] font-bold mt-2">${product.price}</p>
          </div>

          {inCart ? (
        <div className="mt-4 flex items-center justify-between border bg-slate-100 shadow-md rounded-full">
          <button
            onClick={() => {
              if (quantity > 1) {
                setQuantity((prevQuantity) => prevQuantity - 1);
                updateCartCount();
              }
            }}
            className="bg-[#38c13a] text-white py-2 px-4 rounded-lg hover:bg-[#2e9830]"
          >
            -
          </button>
          <span className="text-lg font-semibold">{quantity}</span>
          <button
            onClick={() => {
              setQuantity((prevQuantity) => prevQuantity + 1);
              updateCartCount();
            }}
            className="bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44]"
          >
            +
          </button>
        </div>
      ) : (
        <button
          onClick={handleAddToCart}
          className={`mt-4 bg-[#227d24] text-white py-2 px-4 rounded-lg hover:bg-[#007D44] ${
            product.quantity === 0 ? 'cursor-not-allowed opacity-50' : ''
          }`}
          disabled={product.quantity === 0}
        >
          Add to cart
        </button>
      )}
     
    </div>
  );
}

const LocalProducts = () => {
  const [cartCount, setCartCount] = useState(0);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);


  const [uploadStatus, setUploadStatus] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [cloudinaryUrls, setCloudinaryUrls] = useState({});
  const [products, setProducts] = useState([]);
  const [hasIncompatibleItems, setHasIncompatibleItems] = useState(false); // New state
      

 // Auto-upload products when component mounts
 useEffect(() => {
  const uploadProducts = async () => {
    try {
      setIsUploading(true);

      // Prepare products for upload
      const productsToUpload = ethnicproduct.map(product => ({
        ...product,
        id: product.id,
        name: product.name,
        brand: product.brand,
        description: product.description,
        category: 'ethnicproducts',
        quantity: 0,
        price: parseFloat(product.price.replace('$', ''))
      }));

      try {
        const result = await productService.bulkCreateProducts(productsToUpload);
        
        setUploadStatus({
          success: true,
          message: `${result.created} beauty products uploaded successfully`
        });
      } catch (error) {
        setUploadStatus({
          success: false,
          message: error.response?.data?.message || 'Product upload failed'
        });
      }
    } catch (error) {
      console.error('Error uploading products:', error);
      setUploadStatus({
        success: false,
        message: 'Failed to upload products'
      });
    } finally {
      setIsUploading(false);
    }
  };


  // Fetch products by category
  const fetchProducts = async () => {
    try {
      const result = await productService.getProductsByCategory('ethnicproducts');
      
      // If no products exist, trigger upload
      if (result.count === 0) {
        await uploadProducts();
      } else {
        setProducts(result.products);
        console.log(result.products)
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  fetchProducts();
}, []);

 

  useEffect(() => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items on initial load
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);

  }, []);

  const updateCartCount = () => {
    const storedCartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    setCartCount(storedCartItems.reduce((acc, item) => acc + item.quantity, 0));
    
    // Check for incompatible items whenever cart updates
    const hasIncompatible = storedCartItems.some(item => 
      ["Large Box", "Small Box", "Discount"].includes(item.orderType)
    );
    setHasIncompatibleItems(hasIncompatible);
  };

  const forceUpdateProducts = () => {
    setForceUpdateKey(prevKey => prevKey + 1); // This will force a re-render in ProductCard
  };

  return (
    <>
      <Navbar cartCount={cartCount} updateCartCount={updateCartCount} forceUpdateProducts={forceUpdateProducts} /> {/* Pass cart count to Navbar */}

      {/* Upload Status Notification */}
      {isUploading && (
        <div className="fixed top-0 left-0 w-full bg-yellow-500 text-white text-center py-2 z-50">
          Uploading sponge products...
        </div>
      )}
      
      {uploadStatus && (
        <div 
          className={`
            fixed 
            top-0 
            left-0 
            w-full 
            text-center 
            py-2 
            z-50 
            ${uploadStatus.success ? 'bg-green-500' : 'bg-red-500'} 
            text-white
          `}
        >
          {uploadStatus.message}
        </div>
      )}

      <div className="min-h-screen p-8 max-sm:p-1 lg:mt-[70px] mt-[130px]">
      {hasIncompatibleItems && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">
            Your cart contains items from a different box type. Please complete your current order 
            or clear the cart before selecting individual sponge products.
          </span>
          <button
            onClick={() => setHasIncompatibleItems(false)}
            className="absolute top-0 right-0 px-2 py-1"
          >
            ×
          </button>
        </div>
      )}
        <div className="flex justify-between items-center max-sm:flex-col max-sm:items-start mb-6">
          <h3 className="text-2xl font-semibold">Ethnic Products</h3>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              updateCartCount={updateCartCount}
              forceUpdateKey={forceUpdateKey} // Pass updateCartCount to ProductCard
            />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LocalProducts;